import ArticlePage from './ArticlePage';
import { comparisonArticles } from '@/mocks/articles';

export default function SuperbuyComparisonPage() {
  return <ArticlePage data={comparisonArticles.superbuy} />;
}